import "./App.css";
import Page from "./components/Page/Page";
import { Route, Routes } from "react-router-dom";
import {
  NAME_3_THINGS_TITLE,
  YOUR_FAVOURITE_TITLE,
  CARDS_NAME_3_THINGS,
  FAVS,
} from "./utils/constants";
import Menu from "./components/Menu/Menu";
import Puzzle from "./components/Puzzle/Puzzle";
import Guess from "./components/Guess/Guess";
import Hangman from "./components/Hangman/Hangman";
import Memarts from "./components/Memarts/Memarts";

function App() {
  return (
    <div className='App'>
      <Menu />
      <div className='Page'>
        <Routes>
          <Route exact path='/' element={<Memarts />} />
          <Route
            path='/namethings'
            element={
              <Page title={NAME_3_THINGS_TITLE} list={CARDS_NAME_3_THINGS} />
            }
          />
          <Route
            path='/favs'
            element={<Page title={YOUR_FAVOURITE_TITLE} list={FAVS} />}
          />
          <Route path='/puzzles' element={<Puzzle />} />
          <Route path='/guess' element={<Guess />} />
          <Route path='/hangman' element={<Hangman />} />
          <Route path='/memarts' element={<Memarts />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
